import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  transactionsTable: {
    position: 'relative',
    '& + &': {
      marginTop: '68px',
      '&:before': {
        content: '""',
        height: '40px',
        borderRight: "4px dashed ".concat(palette.shades[500]),
        display: 'inline-block',
        position: 'absolute',
        top: '-68px',
        left: '98px',
        margin: '10px 0',
        [breakpointsFunc.breakpoints.down('md')]: {
          left: '46px'
        }
      }
    }
  },
  // A charge and its meter lines are one entry: no divider between them, and the divider between transactions falls
  // after the meter row. The doubled selectors outrank the table theme's own row and cell rules.
  chargeWithMeters: {
    '&& > td': {
      borderBottom: 'none'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      '&&': {
        paddingBottom: '8px'
      }
    }
  },
  meterRow: {
    [breakpointsFunc.breakpoints.down('md')]: {
      '&&': {
        borderTop: 'none',
        paddingTop: 0
      }
    }
  },
  meterLinesCell: {
    paddingTop: 0
  },
  summaryCell: {
    width: '150px',
    [breakpointsFunc.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  },
  mediumCell: {
    width: '200px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: 'initial'
    }
  },
  smallCell: {
    width: '150px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: 'initial'
    }
  },
  flexWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  utilityCap: {
    paddingRight: '8px',
    flexShrink: '0',
    '& span': {
      marginLeft: '4px'
    }
  },
  transactionAmount: {
    verticalAlign: 'middle',
    display: 'inline-block',
    paddingLeft: '10px',
    flexShrink: '0'
  },
  xsmallCell: {
    width: '80px',
    [breakpointsFunc.breakpoints.down('md')]: {
      width: 'initial'
    }
  },
  hideTablet: {
    [breakpointsFunc.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  showTablet: {
    display: 'none',
    [breakpointsFunc.breakpoints.down('md')]: {
      display: 'inline-block'
    }
  },
  transactionTime: {
    [breakpointsFunc.breakpoints.down('md')]: {
      fontWeight: '600'
    }
  },
  periodCell: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '350px',
    textOverflow: 'ellipsis'
  },
  notesCell: {
    width: '100px'
  },
  chipContainer: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiTypography-root': {
      whiteSpace: 'nowrap',
      marginLeft: '10px'
    }
  }
}));
export default useStyles;